import axiosClient from "@src/utils/axios-client";

export const homePageDetailsAPI = async (params?: any) => {
  try {
    const res = await axiosClient.get(`/admin/rewards/home-page`, { params });

    return res?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const homepageAPI = async (params?: any) => {
  try {
    const res = await axiosClient.put(`/admin/rewards/home-page`, params);
    return res?.data?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const rafflePageDetailsAPI = async (params?: any) => {
  try {
    const res = await axiosClient.get(`/admin/rewards/raffle-page`, { params });
    return res?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const rafflepageAPI = async (params?: any) => {
  try {
    const res = await axiosClient.put(`/admin/rewards/raffle-page`, params);
    return res?.data?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const getResultPageAPI = async (params?: any) => {
  try {
    const res = await axiosClient.get(`/admin/rewards/result-page`, { params });
    return res?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const rewardsResultPageAPI = async (params?: any) => {
  try {
    const res = await axiosClient.put(`/admin/rewards/result-page`, params);
    return res?.data?.data ?? {};
  } catch (error) {
    throw error;
  }
};


export const raffleResultAPI = async (params?: any) => {
  try {
    const res = await axiosClient.get(`/admin/raffles/results`, { params });
    return res?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const rafflePreviousResultAPI = async (params?: any) => {
  try {
    const requestParams = {
      pageNumber: 1,
      pageSize: 10,
      sort: "drawAt,desc",
      ...params,
    };

    const res = await axiosClient.get(
      "/admin/raffles/completed?partnerId=" + params?.partnerId,
      {params: requestParams}
    );

    return res?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const viewWinnerResultAPI = async (params?: any) => {
  try {
    const res = await axiosClient.get(
      `/admin/raffles/${params.id}/result`,
      {params: params}
    );

    return res?.data ?? {};
  } catch (error) {
    throw error;
  }
};


export const raffleEntriesAPI = async (params?: any) => {
  try {

    const result = await axiosClient.get("/admin/raffles/lookup", { params: params });

    return result.data || {};
  } catch (error: any) {
    throw error.response.data.error;
  }
};

export const raffleRNGAPI = async (params?: any) => {
  try {

    const result = await axiosClient.get("/admin/raffles/rng", { params: params });

    return result.data || {};
  } catch (error: any) {
    throw error?.response?.data?.error || error?.response?.data?.message || error?.message || "Failed to fetch";
  }
};